export const BLUE = "#094783";
export const GOLD = "#D19D5F";
export const BG = "#F2F2F2";
export const WHITE = "#FFFFFF";
export const BORDER = "#E3E3E3";
export const MUTED = "#5A6E82";

export const FONT = "'Manrope', system-ui, -apple-system, sans-serif";
